import { andonApi } from "./andon";

export const {
  useToggleHandRaiseMutation,
  useGetAndonWorkstationsQuery,
  useLazyGetAndonWorkstationsQuery,
  useSendSupportBundleMutation
} = andonApi;
